import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value === 'A') {
      return 'Active';
    } else if (value === 'P') {
      return 'Pickup';
    } else if (value === 'S') {
      return 'Stolen';
    } else if (value === 'L') {
      return 'Lost';
    } else if (value === 'D') {
      return 'Draft';
    } else if (value === 'R') {
      return 'Revoked';
    } else {
      return value;
    }
  }

}
